module.exports = __webpack_public_path__ + "static/media/C_F01.5bf92a66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/C_F01.png
// module id = 97
// module chunks = 0